module.exports = require('@atlassian/trello-error-ext') 'Attachment::TypeRestricted'
